import { Card, Stack, Button, Row, Col } from "react-bootstrap";
import Motivo from "./Motivo.jsx";

function ModuloTarjeta({
  id,
  nombre,
  numero,
  estado,
  funcionario,
  motivos,
  onSelect,
  selectedModulo,
}) {
  const styles = {
    card: {
      backgroundColor:
        estado !== "activo"
          ? "var(--color-background)"
          : "var(--color-inactive)",
    },
  };

  const showButton = estado === "inactivo" && !selectedModulo;

  return (
    <Card className="h-100" style={styles.card}>
      <Card.Body className="p-3">
        {/* --- HEADER con Row/Col (NO rebalsa) --- */}
        <Row className="align-items-start g-2 mb-2">
          <Col xs="auto">
            <p className="mb-1 h5">{nombre}</p>
          </Col>

          {showButton && (
            <Col xs="auto" className="ms-auto">
              <Button
                size="sm"
                className="btn-accent btn fw-semibold"
                onClick={onSelect}
                style={{
                  backgroundColor: "var(--color-accent)",
                  color: "var(--color-background)",
                }}
              >
                Atender
              </Button>
            </Col>
          )}
        </Row>

        {/* --- MOTIVOS con wrap --- */}
        <Stack direction="horizontal" className="flex-wrap" gap={1}>
          {motivos.length !== 0 ? (
            motivos
              .filter((m) => m.activo !== false)
              .map((m) => <Motivo key={m.id} motivo={m.nombre} />)
          ) : (
            <Motivo motivo="Sin motivo asignado" />
          )}
        </Stack>

        {/* --- FUNCIONARIO --- */}
        {((selectedModulo && selectedModulo.id === id) || funcionario) && (
          <div className="mt-2">
            <small className="text-muted">
              Atendido por
              {selectedModulo && selectedModulo.id === id
                ? " ti"
                : ": " + funcionario.nombre}
            </small>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default ModuloTarjeta;